import React, { useRef, useEffect } from "react";
import gsap from "gsap";

gsap.registerEffect({
  name: "counter",
  extendTimeline: true,
  defaults: {
    end: 0,
    duration: 0.5,
    ease: "power1",
    increment: 1,
  },
  effect: (targets, config) => {
    let tl = gsap.timeline();
    let num = targets[0].innerText.replace(/\,/g, "");
    targets[0].innerText = num;

    tl.to(
      targets,
      {
        duration: config.duration,
        innerText: config.end,
        modifiers: {
          innerText: function (innerText) {
            return gsap.utils
              .snap(config.increment, innerText)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          },
        },
        ease: config.ease,
      },
      0
    );

    return tl;
  },
});

const NumberCountingAnimation = ({ end, increment, duration, delay }) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;

    if (element) {
      // gsap.from(element, { opacity: 0 });
      gsap.effects.counter(element, {
        end,
        increment,
        duration,
        ease: "linear",
        delay: delay,
      });
    }
  }, [end, increment, duration, delay]);

  return <span ref={elementRef}>0</span>;
};

export default NumberCountingAnimation;
